import { useTheme } from '@approvalmax/theme';
import { pinDrawerState } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import { useMedia } from 'react-use';

export const useContentGridColumns = (): { columns: 2 | 1 } => {
    const { theme } = useTheme();
    const isSmallScreen = useMedia(`(max-width: ${theme.container.breakpoint.medium})`);
    const isMediumScreen = useMedia(`(max-width: ${theme.container.breakpoint.large})`);

    const isDrawerPinned = useAtomValue(pinDrawerState);

    return { columns: (isMediumScreen && isDrawerPinned) || isSmallScreen ? 1 : 2 };
};
